import React from "react";
import { AlertCircle, ShieldPlus } from "lucide-react";
import { Link } from "react-router-dom";

interface PremiumFeatureNoticeProps {
  message: string;
  onDismiss?: () => void;
  title?: string;
  dismissLabel?: string;
  showUpgrade?: boolean;
  upgradeLabel?: string;
  upgradePath?: string;
  variant?: "premium" | "medical";
}

const PremiumFeatureNotice: React.FC<PremiumFeatureNoticeProps> = ({
  message,
  onDismiss,
  title = "Premium Feature",
  dismissLabel = "Dismiss",
  showUpgrade = true,
  upgradeLabel = "Upgrade",
  upgradePath = "/membership",
  variant = "premium",
}) => {
  const styles =
    variant === "medical"
      ? {
          container: "rounded-lg border-2 border-red-600 bg-white p-4",
          icon: "h-5 w-5 text-red-600",
          title: "text-sm font-semibold text-red-700",
          message: "mt-2 text-sm text-red-700",
          dismiss: "text-sm font-semibold text-red-700 hover:text-red-800",
          upgrade: "text-sm font-semibold text-red-600 hover:text-red-700",
        }
      : {
          container: "rounded-lg border border-red-400 bg-yellow-50 p-4",
          icon: "h-5 w-5 text-yellow-400",
          title: "text-sm font-medium text-yellow-800",
          message: "mt-2 text-sm text-yellow-700",
          dismiss: "text-sm font-medium text-yellow-800 hover:text-yellow-900",
          upgrade: "text-sm font-semibold text-red-600 hover:text-red-700",
        };

  return (
    <div className={styles.container}>
      <div className="flex items-center">
        <AlertCircle className={styles.icon} />
        <div className="ml-3">
          <div className="flex items-center gap-1.5">
            <h3 className={styles.title}>{title}</h3>
            {variant === "medical" && (
              <ShieldPlus className="h-4 w-4 text-red-700" aria-hidden="true" />
            )}
          </div>
          <div className={styles.message}>
            <p>{message}</p>
          </div>
          {(onDismiss || showUpgrade) && (
            <div className="mt-4 flex items-center gap-4">
              {onDismiss && (
                <button
                  type="button"
                  onClick={onDismiss}
                  className={styles.dismiss}
                >
                  {dismissLabel}
                </button>
              )}
              {showUpgrade && (
                <Link to={upgradePath} className={styles.upgrade}>
                  {upgradeLabel}
                </Link>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PremiumFeatureNotice;
